import { Filters } from 'components';

const options = [
  {
    value: 'sport',
    translatedValue: 'common.sport',
    subOptions: [
      {
        value: 'basketball',
        translatedValue: 'sports.basketball'
      },
      {
        value: 'soccer',
        translatedValue: 'sports.soccer'
      },
      {
        value: 'baseball',
        translatedValue: 'sports.baseball'
      },
      {
        value: 'americanFootball',
        translatedValue: 'sports.americanFootball'
      }
    ]
  }
];

const CustomFilters = ({ onFilterChange }) => {
  function handleFilterChange(data) {
    onFilterChange(data || {});
  }

  return <Filters options={options} onSubChange={handleFilterChange} />;
};

export default CustomFilters;
